import { AppBar, Avatar, MenuItem, Select, Tab, Table, TableCell, TableContainer, TableHead, TableBody, TableRow, TableSortLabel, Tabs, TextField, Typography, Button } from "@mui/material";
import { Box, Grid } from "@mui/system";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { Label } from "flowbite-react";
import { useEffect, useRef, useState } from "react";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import totalRideIcon from '../../assets/icons/vehicle.svg';
import increment from '../../assets/icons/increment.svg';
import decrement from '../../assets/icons/decrement.svg';
import newUser from '../../assets/icons/newUserIcon.svg';
import activeRidesIcon from '../../assets/icons/activeRides.svg';
import earningsIcon from '../../assets/icons/earningsIcon.svg';
import prevIcon from '../../assets/icons/left-arrow.svg'
import nextIcon from '../../assets/icons/right-arrow.svg';
import config from "../../config/config";
import { makeGetRequestToUrl } from "../commonFunc";
import { useNavigate } from "react-router-dom";
import AnimatedCount from './AnimateCount';

function a11yPropsLatestUser(index){
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const CorporateDashboard = () => {
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const navigate = useNavigate();
    const [monthFilter, setMonthFilter] = useState(new Date().getMonth() + 1);
    const [yearFilter, setYearFilter] = useState(new Date().getFullYear());
    const [latestUserTab, setLatestUserTab] = useState(0);
    const [headerData, setHeaderData] = useState([]);

    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('vehicleName');
    const [rows, setRows] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [paginatedData, setPaginatedData] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [tokenExpired, setTokenExpired] = useState(false);
    const [corporateFilterRows, setCorporateFilterRows] = useState([]);
    const [corporateFilter, setCorporateFilter] = useState('');
    const corporateIdFromLocal = localStorage.getItem('corporateId');

    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...rows].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        setRows(sortedRows);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    useEffect(() => {
        const paginated = Array.isArray(rows)
            ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : [];
        setPaginatedData(paginated);
    }, [rows, page, rowsPerPage]);

    const handleLatestUserChange = (event, newValue) => {
        setLatestUserTab(newValue);
    };

    const fetchStaffSpendReport = async() => {
        try {
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();

            const url = `${serverUrl}/panel/fetch_corporate_spend_dashboard`;
            const effectiveCorporateId = corporateIdFromLocal != 0 ? corporateIdFromLocal : corporateFilter;
            if (!effectiveCorporateId) return;
            const obj={
                token: token, timestamp: timestamp,
                month:  `${yearFilter}-${String(monthFilter).padStart(2, '0')}`,
                status: latestUserTab==0 ? "all" : latestUserTab==1 ? 'active': 'limit',
                corporate_id: effectiveCorporateId,
            }
            // if(corporateFilter) obj.corporate_id=corporateFilter

            const response =  await makeGetRequestToUrl(url, obj);

            if(response.flag == 200 && response.data){
                setHeaderData(response.data?.cardDetails);
                setRows(response.data?.staffReport);
            }
            else if(response.flag==102){
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
            else {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    useEffect(() => {
        fetchStaffSpendReport();
    },[monthFilter, yearFilter, latestUserTab, corporateFilter]);

    const formatMoney = (n) =>  Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    const fetchCorporateData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/corporates/fetch_all';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setCorporateFilterRows(response.data);
                if (response.data?.length && !corporateFilter) {
                    setCorporateFilter(response.data[0].id);
                }
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(() => {
        fetchCorporateData();
    },[]);

    return(
        <div>
            <Grid container sx={{alignItems:'center'}}>
                <Typography style={{ fontSize: '28px', fontWeight: '500'}}>Live Spend Dashboard</Typography>
                <Grid item sx={{marginLeft:'auto', display:'flex', alignItems:'center', gap:2}}>
                    {corporateIdFromLocal == 0 && 
                        <Grid item>
                            <Typography sx={{ fontSize: '14px', color: '#83888E' }}>Corporate</Typography>
                            <Select
                                value={corporateFilter} onChange={(e) => setCorporateFilter(e.target.value)} displayEmpty
                                MenuProps={{
                                    PaperProps: {
                                        sx: {mt:0.5,borderRadius:'10px',boxShadow:'0 4px 20px rgba(0,0,0,0.08)',maxHeight:320}
                                    },
                                }}
                                sx={{
                                    minWidth: 220, height: 40, borderRadius: '8px', backgroundColor: '#FFFFFF',
                                    '& .MuiOutlinedInput-notchedOutline': { borderColor: '#E4E7EC' },
                                    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#0065FF' },
                                }}
                                renderValue={(selected) => {
                                    if (!selected) return <span style={{ color: '#98A2B3' }}>Select Corporate</span>;
                                    const c = corporateFilterRows.find((row) => row.id === selected);
                                    return c ? c.name : selected;
                                }}
                            >
                                {/* <MenuItem value="" sx={{ color: '#98A2B3' }}>Select Corporate</MenuItem> */}
                                {corporateFilterRows.map((corporate) => (
                                    <MenuItem key={corporate.id} value={corporate.id}
                                        sx={{
                                            alignItems: 'flex-start', py: 1,
                                            '&.Mui-selected': { backgroundColor: '#EEF4FF' },
                                            '&.Mui-selected:hover': { backgroundColor: '#E0EBFF' },
                                        }}
                                    >
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', minWidth: 0 }}>
                                            <span style={{ fontSize: '14px', fontWeight: 600, color: '#101828' }}>
                                                {corporate.name}
                                            </span>
                                            <span style={{ fontSize: '12px', color: '#667085' }}>
                                                ID: {corporate.id} · {corporate.email}
                                            </span>
                                        </div>
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid>
                    }
                    <Grid item>
                        <Typography sx={{ fontSize: '14px', color: '#83888E' }}>Month</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Select displayEmpty
                                value={monthFilter} onChange={(e) => setMonthFilter(e.target.value)}
                                sx={{
                                    width: 160, height: 42, backgroundColor: '#FFFFFF', borderRadius: '8px 0 0 8px',
                                    '& .MuiOutlinedInput-notchedOutline': { borderColor: '#E2E5EA' },
                                    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#E2E5EA' },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#0065FF', borderWidth: '1px'},
                                }}
                            >
                                <MenuItem value="" disabled>Month</MenuItem>
                                {[
                                'January', 'February', 'March', 'April', 'May', 'June',
                                'July', 'August', 'September', 'October', 'November', 'December'
                                ].map((name, index) => (
                                    <MenuItem key={index + 1} value={index + 1}>{name}</MenuItem>
                                ))}
                            </Select>

                            <Select displayEmpty
                                value={yearFilter} onChange={(e) => setYearFilter(e.target.value)}
                                sx={{
                                    width: 120, height: 42, backgroundColor: '#FFFFFF', borderRadius: '0 8px 8px 0', ml: '-1px',
                                    '& .MuiOutlinedInput-notchedOutline': { borderColor: '#E2E5EA' },
                                    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#E2E5EA' },
                                    '&.Mui-focused': { zIndex: 1 },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#0065FF',borderWidth: '1px'},
                                }}
                            >
                                <MenuItem value="" disabled>Year</MenuItem>
                                {Array.from({ length: 4 }, (_, i) => new Date().getFullYear() - i).map((yr) => (
                                    <MenuItem key={yr} value={yr}>{yr}</MenuItem>
                                ))}
                            </Select>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>

            <Grid className="mainBox" sx={{marginTop:'1%'}}>
                <Grid container sx={{marginTop: '1%', display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '20px'}}>
                    <Grid item sx={{backgroundColor:'#F3F8FF', padding:'4%', borderRadius:'12px', minHeight:'150px'}}>
                        <img src={totalRideIcon} alt="totalRideIcon" height="32px" width="32px" />
                        <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Total Trips</Typography>
                        {headerData?.total_trips && (
                            <Typography sx={{fontSize:'24px', color:'#1A1E25', fontWeight:'600', marginTop:'4px'}}>
                                {headerData.total_trips.value}
                            </Typography>
                        )}
                        <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
                            {headerData?.total_trips?.change >= 0 ? (
                                <img src={increment} alt="increment" />
                            ) : (
                                <img src={decrement} alt="decrement" />
                            )}
                            {headerData?.total_trips && (
                                <Typography
                                    sx={{
                                        color: headerData.total_trips.change >= 0 ? '#0DBA78' : '#D14545',
                                        fontSize: '12px', marginTop: '8px', marginLeft: '4px',
                                    }}
                                >
                                    {headerData.total_trips.change}%
                                </Typography>
                            )}
                        </Grid>
                    </Grid>

                    <Grid item sx={{backgroundColor:'#EFFBF7', padding:'4%', borderRadius:'12px', minHeight:'150px'}}>
                        <img src={earningsIcon} alt="totalRideIcon" height="32px" width="32px" />
                        <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Total Spend</Typography>
                        {headerData?.total_spend && (
                            <Typography sx={{fontSize:'24px', color:'#1A1E25', fontWeight:'600', marginTop:'4px'}}>
                                {headerData.total_spend.value}
                            </Typography>
                        )}
                        <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
                            {headerData?.total_spend?.change >= 0 ? (
                                <img src={increment} alt="increment" />
                            ) : (
                                <img src={decrement} alt="decrement" />
                            )}
                            {headerData?.total_spend && (
                                <Typography
                                    sx={{
                                        color: headerData.total_spend.change >= 0 ? '#0DBA78' : '#D14545',
                                        fontSize: '12px', marginTop: '8px', marginLeft: '4px',
                                    }}
                                >
                                    {headerData.total_spend.change}%
                                </Typography>
                            )}
                        </Grid>
                    </Grid>

                    <Grid item sx={{backgroundColor:'#F3F8FF', padding:'4%', borderRadius:'12px', minHeight:'150px'}}>
                        <img src={newUser} alt="totalRideIcon" height="32px" width="32px" />
                        <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Active Staff</Typography>
                        {headerData?.active_staff && (
                            <Typography sx={{fontSize:'24px', color:'#1A1E25', fontWeight:'600', marginTop:'4px'}}>
                                {headerData.active_staff.value}
                            </Typography>
                        )}
                        <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
                            {headerData?.active_staff?.change >= 0 ? (
                                <img src={increment} alt="increment" />
                            ) : (
                                <img src={decrement} alt="decrement" />
                            )}
                            {headerData?.active_staff && (
                                <Typography
                                    sx={{
                                        color: headerData.active_staff.change >= 0 ? '#0DBA78' : '#D14545',
                                        fontSize: '12px', marginTop: '8px', marginLeft: '4px',
                                    }}
                                >
                                    {headerData.active_staff.change}%
                                </Typography>
                            )}
                        </Grid>
                    </Grid>

                    <Grid item sx={{backgroundColor:'#FFFBF0', padding:'4%', borderRadius:'12px', minHeight:'150px'}}>
                        <img src={activeRidesIcon} alt="totalRideIcon" height="32px" width="32px" />
                        <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Avg spend per trip</Typography>
                        {headerData?.avg_spend_per_trip && (
                            <Typography sx={{fontSize:'24px', color:'#1A1E25', fontWeight:'600', marginTop:'4px'}}>
                                {headerData.avg_spend_per_trip.value}
                            </Typography>
                        )}
                        <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
                            {headerData?.avg_spend_per_trip?.change >= 0 ? (
                                <img src={increment} alt="increment" />
                            ) : (
                                <img src={decrement} alt="decrement" />
                            )}
                            {headerData?.avg_spend_per_trip && (
                                <Typography
                                    sx={{
                                        color: headerData.avg_spend_per_trip.change >= 0 ? '#0DBA78' : '#D14545',
                                        fontSize: '12px', marginTop: '8px', marginLeft: '4px',
                                    }}
                                >
                                    {headerData.avg_spend_per_trip.change}%
                                </Typography>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid className="mainBox" sx={{marginTop:'1%'}}>
                <Grid container>
                    <Typography sx={{fontSize:'24px', color:'#1A1E25', paddingTop:'1%'}}>Staff Spend Report</Typography>

                    <Grid item sx={{marginLeft:'auto'}}>
                        <AppBar position="static" sx={{minHeight:"10px", maxHeight:'48px', borderRadius:'8px', backgroundColor:'#F9F9F9', padding:'4px', boxShadow:'none', width:'100%'}}>
                            <Tabs value={latestUserTab} onChange={handleLatestUserChange} indicatorColor="secondary"
                            textColor="inherit"  aria-label="full width tabs example" >
                                <Tab label="All" className={latestUserTab === 0 ? 'tabHeader active' : 'tabHeader'} sx={{textTransform:'none'}} {...a11yPropsLatestUser(0)} />
                                <Tab label="Active" className={latestUserTab === 1 ? 'tabHeader active' : 'tabHeader'} sx={{textTransform:'none'}} {...a11yPropsLatestUser(1)} />
                                <Tab label="Limit Reached" className={latestUserTab === 2 ? 'tabHeader active' : 'tabHeader'} sx={{textTransform:'none'}} {...a11yPropsLatestUser(2)} />
                            </Tabs>
                        </AppBar>

                    </Grid>

                    <TableContainer className="table-container" sx={{maxHeight:'56vh'}}>
                        <Table stickyHeader className="scrollable-table">
                            <TableHead>
                                <TableRow>
                                    <TableCell component="th" align="center" className="table-header" style={{ width: '12%' }}>
                                        <TableSortLabel
                                            active={orderBy === 'user_id'}
                                            direction={orderBy === 'user_id' ? order : 'asc'}
                                            onClick={() => handleRequestSort('user_id')}
                                        >
                                            User Id
                                        </TableSortLabel>
                                    </TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%' }}>User</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '12%' }}>Spend</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '12%' }}>Trips Used</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '18%' }}>Remaining Budget</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '18%' }}>Remaining Trips</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%' }}>Status</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {paginatedData.length==0 && 
                                    <TableRow>
                                        <TableCell colSpan={16} align="center">
                                            <Typography variant="body1">No data found</Typography>
                                        </TableCell>
                                    </TableRow>
                                }
                                {paginatedData && (paginatedData).map((row) => (
                                    <TableRow>
                                        <TableCell>{row.user_id}</TableCell>
                                        <TableCell sx={{justifyItems:'center'}}>
                                            <Grid container sx={{ width:'auto', minWidth:'180px'}}>
                                                <Grid>
                                                    <Avatar sx={{borderColor:'#0065FF', border:1, color:'#0065ff', bgcolor:"#EAF1FF"}} alt={row.user_name} src={row.user_image} ></Avatar>
                                                </Grid>
                                                <Grid item sx={{ml:'12px',textAlign:'left'}}>
                                                    <Grid>
                                                        <Typography sx={{fontSize:'14px'}}>{row.user_name}</Typography>
                                                        <Typography sx={{fontSize:'12px'}}>{row.designation}</Typography>
                                                        <Typography sx={{fontSize:'12px', color:'#0065ff'}}>{row.emp_id}</Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </TableCell>
                                        <TableCell>{row.spend}</TableCell>
                                        <TableCell>{row.trips}</TableCell>
                                        <TableCell align="center">
                                            {row.spend_cap != null ? (
                                                <Box sx={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', gap: '6px', minWidth: 110 }}>
                                                    <Typography sx={{ fontSize: 14, fontWeight: 500, color: '#1A1E25' }}>
                                                        {formatMoney(row.remaining_budget)}
                                                    </Typography>
                                                    <Box sx={{ width: '100%', height: 6, borderRadius: 999, backgroundColor: '#EDEFF2', overflow: 'hidden' }}>
                                                        {(() => {
                                                        const usedPct = Math.max(0, Math.min(100, ((row.spend_cap - row.remaining_budget) / row.spend_cap) * 100));
                                                        const barColor = usedPct >= 100 ? '#D14545' : usedPct >= 80 ? '#C88A1E' : '#0DBA78';
                                                        return (
                                                            <Box sx={{ width: `${usedPct}%`, height: '100%', borderRadius: 999, backgroundColor: barColor }} />
                                                        );
                                                        })()}
                                                    </Box>
                                                </Box>
                                            ) : (
                                                <Typography sx={{ color: '#C4C8CE' }}>—</Typography>
                                            )}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row.trip_limit != null ? (
                                                <Box sx={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', gap: '6px', minWidth: 110 }}>
                                                    <Typography sx={{ fontSize: 14, fontWeight: 500, color: '#1A1E25' }}>
                                                        {row.remaining_trips}
                                                    </Typography>
                                                    <Box sx={{ width: '100%', height: 6, borderRadius: 999, backgroundColor: '#EDEFF2', overflow: 'hidden' }}>
                                                        {(() => {
                                                        const usedPct = Math.max(0, Math.min(100, ((row.trip_limit - row.remaining_trips) / row.trip_limit) * 100));
                                                        const barColor = usedPct >= 100 ? '#D14545' : usedPct >= 80 ? '#C88A1E' : '#0DBA78';
                                                        return (
                                                            <Box sx={{ width: `${usedPct}%`, height: '100%', borderRadius: 999, backgroundColor: barColor }} />
                                                        );
                                                        })()}
                                                    </Box>
                                                </Box>
                                            ) : (
                                                <Typography sx={{ color: '#C4C8CE' }}>—</Typography>
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            <Button
                                                variant="contained"
                                                style={{
                                                    backgroundColor: row.status=="active" ? '#E7F8F2': '#FBEFD2',
                                                    color: row.status=="active" ? '#0DBA78': '#B07D18',
                                                    textTransform: 'none',
                                                    pointerEvents: 'none',
                                                    borderRadius: '6px',
                                                    minWidth: '40px',
                                                    border:'none',
                                                    boxShadow: 'none',
                                                }}
                                            >
                                                <FiberManualRecordIcon style={{ fontSize: '12px', marginRight:'8px' }}/>{row.status}
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        <div className="custom-pagination">
                            <div className="pagination-info">
                                {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                                    (page + 1) * rowsPerPage,
                                    rows.length
                                )} of ${rows.length} entries`}
                            </div>
                            <div className="pagination-controls">
                                <button
                                    onClick={() => handleChangePage(null, page - 1)}
                                    disabled={page === 0}
                                    className="pagination-arrow"
                                >
                                    <img src={prevIcon} alt="Previous" />
                                </button>
                    
                                <div className="pagination-numbers">
                                    {page > 1 && (
                                        <>
                                            <button onClick={() => handleChangePage(null, 0)} className="pagination-number">
                                                1
                                            </button>
                                            <span className="pagination-dots">...</span>
                                        </>
                                    )}
                                    {[...Array(Math.ceil(rows.length / rowsPerPage))]
                                        .map((_, index) => index)
                                        .filter((index) => index >= page - 1 && index <= page + 1) // Show only previous, current, and next page
                                        .map((index) => (
                                            <button
                                                key={index}
                                                onClick={() => handleChangePage(null, index)}
                                                className={`pagination-number ${page === index ? 'active' : ''}`}
                                            >
                                                {index + 1}
                                            </button>
                                    ))}

                                    {page < Math.ceil(rows.length / rowsPerPage) - 2 && (
                                        <>
                                            <span className="pagination-dots">...</span>
                                            <button
                                                onClick={() => handleChangePage(null, Math.ceil(rows.length / rowsPerPage) - 1)}
                                                className="pagination-number"
                                            >
                                                {Math.ceil(rows.length / rowsPerPage)}
                                            </button>
                                        </>
                                    )}
                                </div>
                                <button
                                    onClick={() => handleChangePage(null, page + 1)}
                                    disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                                    className="pagination-arrow"
                                >
                                    <img src={nextIcon} alt="Next" />
                                </button>
                            </div>
                        </div>
                    </TableContainer>
                </Grid>
            </Grid>
        </div>
    )
}

export default CorporateDashboard;